import React from 'react';

import { Banner, BANNER_TYPES } from '@sravni/react-advertisement';

import { useBanners, useLoadingBanners } from '../../hooks/advertising';
import { useMaterials, useMaterialsList } from '../../hooks/news';
import { useIsItemPage } from '../../hooks/pageType';

export const TopBanner = () => {
  const isLoadingBanner = useLoadingBanners(BANNER_TYPES.TOP);
  const isItemPage = useIsItemPage();

  const materialAlias = (isItemPage ? useMaterials : useMaterialsList)()?.[0]?.alias;

  const banners = useBanners(materialAlias);
  if (!banners?.top && !isLoadingBanner) return null;

  return <Banner abName="" banner={banners?.[BANNER_TYPES.TOP]} type={BANNER_TYPES.TOP} hasPlaceholder />;
};
